module.exports = __webpack_public_path__ + "media/images/riders/RETO_INDERGAND-a212f61e8265841adc1e35f088691cc9.png";